function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "poster",
  className: "o-livingroom-poster"
}, React.createElement("path", {
  fill: "#3B4956",
  className: "o-svg-dark",
  d: "M58.9,12.3H56l-9.3-7.2c0.3-0.2,0.5-0.5,0.5-0.9C47.2,3.6,46.7,3,46,3s-1.2,0.5-1.2,1.2c0,0.4,0.2,0.7,0.5,0.9l-8.7,7.2 h-3.1c-0.5,0-0.9,0.4-0.9,0.9v17.5c0,0.5,0.4,0.9,0.9,0.9h25.4c0.5,0,0.9-0.4,0.9-0.9V13.2C59.8,12.7,59.4,12.3,58.9,12.3z  M46.1,6.8l7,5.5H39.5L46.1,6.8z M58,29.8H34.5V14.1H58V29.8z"
}), React.createElement("path", {
  fill: "#3B4956",
  className: "o-svg-dark",
  d: "M37.3,28.3h17.9c0.5,0,0.9-0.4,0.9-0.9V16.5c0-0.5-0.4-0.9-0.9-0.9H37.3c-0.5,0-0.9,0.4-0.9,0.9v10.9 C36.4,27.9,36.8,28.3,37.3,28.3z M38.2,17.4h16.1v9.1H38.2V17.4z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#3B4956",
  className: "o-svg-dark",
  d: "M109.5,18.5c-0.1-0.4-0.4-0.8-0.9-0.8h-8.4c-0.4,0-0.8,0.3-0.9,0.8l-3.1,22.1c0,0.3,0,0.5,0.2,0.7s0.4,0.3,0.7,0.3h6.3 v22.7c-3.4,0.4-6,3.3-6,6.8c0,0.5,0.4,0.9,0.9,0.9h12c0.5,0,0.9-0.4,0.9-0.9c0-0.1,0-0.1,0-0.2c-0.1-3.4-2.7-6.2-6-6.6V41.6h1.7 v6.6c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-6.6h2.8c0.3,0,0.5-0.1,0.7-0.3s0.2-0.5,0.2-0.7L109.5,18.5z M109.3,70.2h-10 c0.4-2.4,2.5-4.2,5-4.2S108.9,67.9,109.3,70.2z M98.2,39.8l2.9-20.3h6.8l2.7,20.3H98.2z"
}), React.createElement("path", {
  fill: "#3B4956",
  className: "o-svg-dark",
  d: "M92.5,58.8v-9.4c0-2.3-1.5-4.2-3.6-4.8c0,0,0,0,0-0.1c-1-4.3-4.8-7.3-9.2-7.3H13.1c-4.4,0-8.3,3.1-9.2,7.4 C1.7,45.2,0,47.1,0,49.5v9.3v0.1v8.9c0,0.5,0.4,0.9,0.9,0.9H2v1.9c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-1.9h84.6v1.9 c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-1.9h1.4c0.5,0,0.9-0.4,0.9-0.9V59C92.5,58.9,92.5,58.9,92.5,58.8z M60,58.1v-2.5h22.4 v2.5H60z M10.1,55.6H31v2.5H10.1V55.6z M32.8,55.6h25.5v2.5H32.8V55.6z M32.8,53.8V39h25.5v14.8H32.8z M90.7,49.4v8.5h-6.5v-8.5 c0-1.8,1.4-3.2,3.2-3.2C89.3,46.2,90.7,47.6,90.7,49.4z M87,44.4c-2.6,0.2-4.6,2.4-4.6,5v4.4H60V39h19.7C83.1,39,86,41.2,87,44.4z  M13.1,39H31v14.8H10.1v-4.3c0-2.5-1.9-4.6-4.3-5C6.7,41.4,9.7,39,13.1,39z M1.8,49.5c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2V58 H1.8V49.5z M90.7,67H1.8v-7.1h88.9C90.7,59.9,90.7,67,90.7,67z"
})));

var SvgLivingroom = function SvgLivingroom(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113 72",
    style: {
      enableBackground: "new 0 0 113 72"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/livingroom.b21715b5.svg";
export { SvgLivingroom as ReactComponent };